<script context="module">
  import { writable } from "svelte/store";
  let state = writable({
    showing: false
  });
</script>

<script>
  import { spring } from "svelte/motion";
  import { onMount } from "svelte";
  import { fade, scale } from "svelte/transition";
  import { backOut, elasticOut } from "svelte/easing";
  import ToggleSliderComponent from "./ToggleSliderComponent.svelte";

  export let imagesrc = "";
  export let position = {};
  export let rotation = 0;
  export let delay = 0;
  export let isButton = false;
  export let isVisible;

  let isDragging = false;

  let coords = spring(
    { x: position.x, y: position.y },
    {
      stiffness: 0.08,
      damping: 0.3
    }
  );

  let dragXPos = null;
  let dragYPos = null;
  let elWidth = 0;

  function onDragStart(event) {
    elWidth = event.srcElement.clientWidth;
    event.preventDefault();
    isDragging = true;
  }

  function onDrag(event, index) {
    if (!isDragging) return;

    dragXPos = event.clientX - elWidth / 2;
    dragYPos = event.clientY - elWidth / 2;

    coords.set({ x: dragXPos, y: dragYPos });
  }

  function onDragEnd(event, index) {
    if (!isDragging) return;

    dragXPos = event.clientX - elWidth / 2;
    dragYPos = event.clientY - elWidth / 2;

    isDragging = false;

    coords.set({ x: dragXPos, y: dragYPos });
  }

  function toggleStickers() {
    state.set({
      showing: !$state.showing
    });
  }
</script>

<style>
  .sticker-component--box {
    position: absolute;
    max-height: 300px;
    max-width: 300px;
    display: block;
    z-index: 10;
    pointer-events: all;
    cursor: pointer;
  }
  img {
    max-width: 100%;
    max-height: 100%;
  }
</style>

<svelte:body on:mousemove={onDrag} on:mouseup={onDragEnd} />

<!--All Stickers-->
{#if isVisible && !isButton && $state.showing}
  <div
    class="sticker-component--box"
    style="transform: translate3d({$coords.x}px, {$coords.y}px, 0) rotate({rotation}deg)"
    on:mousedown={onDragStart}
    in:scale={{ delay: delay, duration: 2400, easing: elasticOut }}
    out:scale={{ delay: delay, duration: 1200, easing: elasticOut }}>
    <img src={imagesrc} alt="sticker" />
  </div>
{/if}

<!--Toggle Button Sticker-->
{#if isButton && isVisible}
  <div
    class="sticker-component--box"
    style="transform: translate3d({$coords.x}px, {$coords.y}px, 0) rotate({rotation}deg)"
    on:mousedown={onDragStart}
    in:scale={{ delay: delay, duration: 2600, easing: elasticOut }}>
    <ToggleSliderComponent on:toggleStickers={toggleStickers} />
    <img src={imagesrc} alt="sticker" />
  </div>
{/if}
